module.exports = "<div class=\"container\">\n    <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/account/register/register.component.html
// module id = 772
// module chunks = 0